
import PropTypes from 'prop-types'
import React from 'react'

const Card = props => {
  const divStyle = {
    width: 30,
    height: 18
  }

  const svgStyle = {
    display: 'block'
  }

  return (
    <div style={divStyle} className={props.class}>
      <svg style={svgStyle} width='30' height='18' viewBox='425 26 30 18' xmlns='http://www.w3.org/2000/svg'>
        <g stroke='#FFF' strokeWidth='1.5' fill='none' fillRule='evenodd' strokeLinecap='round' strokeLinejoin='round'>
          <path d='M452.36 42.25h-17.494a1.825 1.825 0 0 1-1.824-1.825V29.109c0-1.008.817-1.825 1.824-1.825h17.494c1.008 0 1.825.817 1.825 1.825v11.316a1.825 1.825 0 0 1-1.825 1.825zm1.825-4.039h-21.143' />
          <path d='M445.804 33.144l1.456-1.72 1.39 1.72 1.424-1.72m-11.819 3.579h-1.963m4.963 0h-.963m-10.495-2.236h-1.514m1.514 4h-3.047' />
        </g>
      </svg>
    </div>
  )
}

Card.propTypes = {
  class: PropTypes.string
}

Card.displayName = 'Card'

export default Card



// WEBPACK FOOTER //
// ./ui/icons/card.js